import React, { lazy, Suspense, useEffect, useState } from 'react';
import BonusTab from './BonusTab';
import Grid from '@mui/material/Grid2';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { setNewBonus } from 'src/store/apps/userSlice';
import { ProfileTabs } from './data';
import useGroupByGroupId from '../../../hooks/site/useGroupByGroupId';
import useAuthEffect from '../../../hooks/useAuthEffect';
import { API_GROUP } from '../../../api/user';
import PageContainer from '../../../components/container/PageContainer';
import ShowContainer from '../../../components/material-ui/ShowContainer';
import Spinner from '../../../components/material-ui/spinner/Spinner';
import ErrorBoundary from '../../../components/material-ui/error_boundary/ErrorBoundary';
import { dispatchCusEvent } from '../../../utils';
import { ENUM_CUS_EVENT } from '../../../enums/enums';

const GroupBreadcrumb = lazy(() => import('../../../components/shared/GroupBreadcrumb'));

export default function BonusesDash() {
  const { id: defaultTab } = useParams();
  const { group, groupId } = useGroupByGroupId();

  const [activeTab, setActiveTab] = useState(defaultTab);
  const [groupByPromo, setGroupByPromo] = useState(undefined);
  const isGame = group?.game;

  useEffect(() => {
    setActiveTab(defaultTab);
  }, [defaultTab]);

  useAuthEffect(() => {
    if (!isGame) return;

    API_GROUP.linkPromo
      .get(groupId)
      .then((e) => {
        setGroupByPromo(e.data.state);
      })
      .catch(console.log);
  }, [isGame, groupId]);

  useAuthEffect(() => {
    dispatchCusEvent(ENUM_CUS_EVENT.getBonusList, { groupId });

    if (!group || group.game) dispatchCusEvent(ENUM_CUS_EVENT.getJackpotsList, { groupId });
  }, [groupId]);

  const BonusTypeController = () => {
    const curTab = ProfileTabs.find((el) => el.id === activeTab);
    if (curTab) {
      return (
        <curTab.element
          groupId={groupId}
          group={group}
          groupByPromo={groupByPromo}
          setGroupByPromo={setGroupByPromo}
        />
      );
    }
    return <></>;
  };

  return (
    <PageContainer title="Bonus management" description="">
      <ShowContainer condition={group} plug={<Spinner />}>
        <ErrorBoundary>
          <Suspense>
            <GroupBreadcrumb
              group={group}
              title={'Bonus management'}
              urlById={(id) => `/bonuses/${activeTab}/${id}`}
            />
          </Suspense>
        </ErrorBoundary>
        <Grid container spacing={0}>
          <Grid size={12}>
            <BonusTab
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              groupId={groupId}
              isGameGroup={isGame}
            />
          </Grid>
          <Grid size={12}>
            <ErrorBoundary>
              <BonusTypeController />
            </ErrorBoundary>
          </Grid>
        </Grid>
      </ShowContainer>
    </PageContainer>
  );
}
